"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkDialog = exports.LinkDialogDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var dialog_1 = require("../elements/dialog");
var entity_search_select_1 = require("./entity-search-select");
var use_icons_1 = require("../../hooks/use-icons");
var use_lang_1 = require("../../hooks/use-lang");
var icon_button_1 = require("../elements/icon-button");
var use_entities_1 = require("../../hooks/use-entities");
var form_field_text_1 = require("../../v2/elements/form-field-text");
exports.LinkDialogDefaultProps = {
  text: '',
  entityTypeNames: ['Organisation', 'Person', 'Page', 'Topic', 'Trend', 'SubTopic', 'Challenge', 'KeyIssue', 'Post'],
  onConfirm: function (entity) {
    console.log(entity);
  }
};
// -------- Child Component Props -------->
// -------- Styles -------->
var DialogStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 0;\n    width: 80vw;\n    max-width: 600px;\n  "], ["\n    padding: 0;\n    width: 80vw;\n    max-width: 600px;\n  "])))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "])))
});
var SearchStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: ", " 0;\n  "], ["\n    margin: ", " 0;\n  "])), theme_1.theme.UNIT(4))
});
var ButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin: ", " 0;\n  "], ["\n    margin: ", " 0;\n  "])), theme_1.theme.UNIT(1))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    border-left: 2px solid ", ";\n    padding-left: ", ";\n    margin: ", " 0 ", ";\n    color: ", ";\n    font-size: ", ";\n  "], ["\n    border-left: 2px solid ", ";\n    padding-left: ", ";\n    margin: ", " 0 ", ";\n    color: ", ";\n    font-size: ", ";\n  "])), theme_1.theme.COLOR('line-subtle'), theme_1.theme.UNIT(3), theme_1.theme.UNIT(1.5), theme_1.theme.UNIT(0.5), theme_1.theme.COLOR('text-subtle'), theme_1.theme.FONT_SIZE(13))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: ", ";\n    font-weight: 500;\n    text-transform: uppercase;\n    color: ", ";\n\n  "], ["\n    font-size: ", ";\n    font-weight: 500;\n    text-transform: uppercase;\n    color: ", ";\n\n  "])), theme_1.theme.FONT_SIZE(14), theme_1.theme.COLOR('text'))
});
var InputStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    width: 100%;\n    box-sizing: border-box;\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "], ["\n    width: 100%;\n    box-sizing: border-box;\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(6))
});
// -------- Components -------->
var My = {
  Dialog: (0, styled_components_1.default)(dialog_1.Dialog)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), DialogStyles),
  Body: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Input: (0, styled_components_1.default)(form_field_text_1.FormFieldText)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), InputStyles),
  Description: styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  Label: styled_components_1.default.label(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Search: (0, styled_components_1.default)(entity_search_select_1.EntitySearchSelect)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), SearchStyles),
  Button: (0, styled_components_1.default)(icon_button_1.IconButton)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles)
};
var LinkDialog = function (props) {
  var _a;
  var className = props.className,
    entityTypeNames = props.entityTypeNames,
    onConfirm = props.onConfirm,
    onCancel = props.onCancel;
  var entities = (0, use_entities_1.useEntities)();
  var t = (0, use_lang_1.useLang)();
  var title = t('Insert Link');
  var _b = __read((0, react_1.useState)(''), 2),
    url = _b[0],
    setUrl = _b[1];
  var _c = __read((0, react_1.useState)(props.text), 2),
    text = _c[0],
    setText = _c[1];
  var Icons = (0, use_icons_1.useIcons)();
  var _d = __read((0, react_1.useState)(), 2),
    value = _d[0],
    setValue = _d[1];
  var resultUrl = (url === null || url === void 0 ? void 0 : url.trim()) || ((_a = value === null || value === void 0 ? void 0 : value.entity) === null || _a === void 0 ? void 0 : _a.sitePath);
  var button = react_1.default.createElement(My.Button, {
    disabled: !value && !url,
    onClick: function () {
      onConfirm(resultUrl, text);
    },
    icon: react_1.default.createElement(Icons.TickCircle, null)
  }, t('Insert Link'));
  return react_1.default.createElement(My.Dialog, {
    icon: Icons.Entities.Link,
    title: title,
    onCancel: onCancel,
    showCancelButton: true,
    className: className,
    button: button
  }, react_1.default.createElement(My.Body, null, react_1.default.createElement(My.Label, null, t('Link Text')), react_1.default.createElement(My.Description, null, t('Enter the text you want to show for the link. Note: this will match any text selection you had in the editor, and changing this will change any text selection in the editor.')), react_1.default.createElement(My.Input, {
    onChange: function (result) {
      setText(result.value);
    },
    value: text,
    name: "text"
  }), react_1.default.createElement(My.Label, null, t('Enter Link URL')), react_1.default.createElement(My.Description, null, t('Enter a URL (full web address with https and a domain) for the link, or a relative URL, which should begin with a leading /')), react_1.default.createElement(My.Input, {
    autoFocus: true,
    onChange: function (result) {
      setUrl(result.value);
    },
    value: url,
    placeholder: "https://domain.com or /path/to/item",
    name: "url"
  }), react_1.default.createElement(My.Label, null, t('OR Link to a Platform Item')), react_1.default.createElement(My.Description, null, t('Search for a platform item to link to. Note: when preparing content for a website, only link to items you know are published on the site (this will vary depending on the site):')), react_1.default.createElement(My.Search, {
    isSearchable: true,
    isClearable: true,
    entityTypeNames: entityTypeNames,
    variant: "default",
    value: value,
    onChange: function (value) {
      setValue(value);
      if (!text) {
        setText(value.entity.name);
      }
    }
  })));
};
exports.LinkDialog = LinkDialog;
exports.LinkDialog.defaultProps = exports.LinkDialogDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;